import React from 'react';
import { FadeIn } from './FadeIn';
export function StoryHook() {
  return <section className="py-16 md:py-32 bg-white relative" data-id="element-397">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-398">
        <FadeIn data-id="element-399">
          <div className="relative" data-id="element-400">
            {/* Decorative quote mark */}
            <span className="absolute -top-10 -left-8 text-8xl text-sage-200 font-serif leading-none select-none opacity-50" data-id="element-401">
              "
            </span>

            <p className="text-xl md:text-2xl leading-relaxed text-charcoal font-serif italic mb-8 relative z-10" data-id="element-402">
              Es lunes por la mañana. Suena el despertador y lo primero que
              sientes no es descanso, sino una pesadez que te nubla la vista.
              Llegas al espejo y lo ves: tu cara está hinchada, tus manos se
              sienten apretadas y, al intentar subir el cierre de tu pantalón
              favorito, simplemente no cierra.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-403">
          <div className="pl-6 border-l-4 border-coral-400" data-id="element-404">
            <p className="text-lg md:text-xl text-charcoal-light leading-relaxed" data-id="element-405">
              No es "grasa" acumulada por falta de voluntad.{' '}
              <strong className="text-charcoal font-semibold" data-id="element-406">
                Es tu cuerpo gritando por ayuda.
              </strong>{' '}
              Estás atrapada en un ciclo de inflamación silenciosa que ningún
              jugo verde o cardio excesivo puede solucionar.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}